export default __webpack_public_path__ + "static/media/dhl-icon.c6bf25e5.svg";